import { type RefObject, useEffect, useState } from 'react';

import { MAX_HEIGHT } from './constants';

const useIsCollapsable = (ref: RefObject<HTMLDivElement>) => {
  const [isCollapsable, setIsCollapsable] = useState(false);

  useEffect(() => {
    if (ref.current?.clientHeight && ref.current.clientHeight >= MAX_HEIGHT) {
      setIsCollapsable(true);
    }
  }, [ref]);

  return isCollapsable;
};

export default useIsCollapsable;
